import { useMemo, useState } from 'react'
import ReactDOM from 'react-dom/client'
import PlanFilters from './floorplans/plan-filters.jsx'
import PlanList from './floorplans/plan-list.jsx'
import PlanView from './floorplans/plan-view.jsx'
import { FloorplansContext } from './floorplans/floorplans-context.jsx'

function App() {
  const [bedroomsFilter, setBedroomsFilter] = useState('all')
  const [planLevelsFilter, setPlanLevelsFilter] = useState('all')
  const [activePlan, setActivePlan] = useState(null)
  const bedroomOptions = floorplanData?.bedroom_options || []

  const contextValue = useMemo(
    () => ({
      bedroomOptions,
      bedroomsFilter,
      setBedroomsFilter,
      planLevelsFilter,
      setPlanLevelsFilter,
      activePlan,
      setActivePlan,
    }),
    [bedroomOptions, bedroomsFilter, planLevelsFilter, activePlan]
  )

  const shouldShowPlan = () => {
    const plans = floorplanData?.plans || []
    const plan = plans.find((p) => p.plan_id === activePlan)

    return (activePlan && plan)
  }

  const sectionClass = (shouldShowPlan()) ? 'app-grid show-plan' : 'app-grid'

  return (
    <FloorplansContext.Provider value={contextValue}>
      <div className={ sectionClass }>
        <PlanFilters />
        <PlanList />
        <PlanView />
      </div>
    </FloorplansContext.Provider>
  )
}

const root = ReactDOM.createRoot(document.getElementById('floorplanAppRoot'))
root.render(<App />)